import { DailyLoginStreakSlice } from "./types";

export const initialState: DailyLoginStreakSlice = {
	data: undefined,
	tracker: undefined,
	isClaiming: false
};
